import ROUTES from "@config/routes";
import {
  legacyPermissionRouteMap,
  LegacyTypesPermissions,
} from "@components/Routes/legacyTypesPermissions";
import {
  permissionRouteMap,
  ROLE_CARRIER,
  ROLE_CIF_DRIVER,
  ROLE_FOB_DRIVER,
  TypesPermissions,
} from "@components/Routes/TypesPermissions";
import { TypesProfile } from "@context/auth/enum";
import { normalizeModule } from "@utils/index";

export const getFirstPermittedRouteLegacy = (
  permissions: string[],
  roles: string[]
): string => {
  sessionStorage.setItem("detectedFirstAccess", "true");

  if (
    roles.includes(TypesProfile.ADMIN) ||
    permissions.includes(LegacyTypesPermissions.HOME.slice(0, -2))
  ) {
    return legacyPermissionRouteMap[LegacyTypesPermissions.HOME];
  }

  for (const permission of permissions) {
    const route = legacyPermissionRouteMap[`${permission}:*`];
    if (route) {
      return route;
    }
  }

  return ROUTES.USER_ROUTES.NOTFOUND;
};

export const getFirstPermittedRouteV2 = (
  permissions: string[],
  roles: string[]
): string => {
  sessionStorage.setItem("detectedFirstAccess", "true");

  if (roles.includes(TypesProfile.ADMIN)) {
    return permissionRouteMap[TypesPermissions.ADMIN_HOME];
  }

  if (
    roles.includes(ROLE_CIF_DRIVER) ||
    roles.includes(ROLE_CARRIER) ||
    roles.includes(ROLE_FOB_DRIVER)
  ) {
    return permissionRouteMap[TypesPermissions.APPOINTMENT];
  }

  const homeTarget = "portal_cliente:home";
  if (permissions.some((p) => normalizeModule(p) === homeTarget)) {
    return permissionRouteMap[TypesPermissions.HOME];
  }

  for (const permission of permissions) {
    const route = permissionRouteMap[`${normalizeModule(permission)}:*`];
    if (route) return route;
  }

  return ROUTES.USER_ROUTES.NOTFOUND;
};

export const getFirstPermittedRoute = (
  permissions: string[],
  roles: string[],
  useSystemModulesAuth: boolean
): string => {
  if (useSystemModulesAuth) {
    return getFirstPermittedRouteV2(permissions, roles);
  }
  return getFirstPermittedRouteLegacy(permissions, roles);
};
